// removed by extract-text-webpack-plugin
module.exports = {"spinner":"spinner__2tt7KAvHFYAQ","active":"active__c5MniMlYFh8H","refreshIcon":"refreshIcon__2BSwUFMtS5HL"};